import styled from '@emotion/styled';
import { IconTitleWrapper } from '../IconAndTitleLayout/styled';
export var SpinnerWrapper = styled(IconTitleWrapper)({
  verticalAlign: 'baseline',
  marginLeft: "var(--ds-space-025, 2px)"
});